import { render, staticRenderFns } from "./insertSheetData.vue?vue&type=template&id=10b34e6b&scoped=true&"
import script from "./insertSheetData.vue?vue&type=script&lang=js&"
export * from "./insertSheetData.vue?vue&type=script&lang=js&"
import style0 from "./insertSheetData.vue?vue&type=style&index=0&id=10b34e6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b34e6b",
  null
  
)

export default component.exports